module.exports = new __parcel__URL__("puppy2.28a0168d.png").toString();